export enum digitalBalanceRequestsTableTypes {
	DIGITAL_BALANCE_REQUESTS = 'digitalBalanceRequests',
}

export type digitalBalanceColumnType = 'string' | 'date' | 'custom';

export type digitalBalanceTableColumns = {
	[digitalBalanceRequestsTableTypes.DIGITAL_BALANCE_REQUESTS]: {
		companyName: digitalBalanceColumnType;
		hyperAccountNumber: digitalBalanceColumnType;
		createdAt: digitalBalanceColumnType;
		feezbackUpdatedAt: digitalBalanceColumnType;
		amount: digitalBalanceColumnType;
		customerName: digitalBalanceColumnType;
		clientBankAccount: digitalBalanceColumnType;
		altshulerBankAccount: digitalBalanceColumnType;
		feezbackBankReferenceNumber: digitalBalanceColumnType;
		documentedOnHyperAction: digitalBalanceColumnType;
		documentedOnHyperDate: digitalBalanceColumnType;
		documentedByBoUser: digitalBalanceColumnType;
	};
};

// Column config for documented digital balance requests table
const BASE_COLUMNS = [
	'createdAt',
	'companyName',
	'feezbackUpdatedAt',
	'amount',
	'customerName',
	'clientBankAccount',
	'altshulerBankAccount',
	'hyperAccountNumber',
	'feezbackBankReferenceNumber',
];
export const DOCUMENTED_COLUMNS = [...BASE_COLUMNS, 'documentedOnHyperDate', 'documentedByBoUser'];
export const DIGITAL_BALANCE_SORTABLE_COLUMNS = [
	'createdAt',
	'feezbackUpdatedAt',
	'amount',
	'documentedOnHyperDate',
	'feezbackBankReferenceNumber',
];

export const digitalBalanceTableColumnsConfig: digitalBalanceTableColumns = {
	[digitalBalanceRequestsTableTypes.DIGITAL_BALANCE_REQUESTS]: {
		createdAt: 'date',
		companyName: 'string',
		hyperAccountNumber: 'string',
		feezbackUpdatedAt: 'date',
		amount: 'custom',
		customerName: 'string',
		clientBankAccount: 'string',
		altshulerBankAccount: 'string',
		feezbackBankReferenceNumber: 'string',
		documentedOnHyperAction: 'custom',
		documentedOnHyperDate: 'date',
		documentedByBoUser: 'string',
	},
};
